export default {
  dev: window.location.hostname.indexOf('localhost') > -1 || window.location.hostname.indexOf('192.168') > -1,
  meta: {
    title: 'Coco Coders',
    titleSuffix: 'Coco Coders',
    description: `Coding lessons for kids`,
    keywords: `kids coding lessons`
  },
  googleTagManager: {}
};